import { compareLabel } from '~/util/compareLabel'

/** Distinct, non-null value_types from walk rows, sorted for display. */
export function distinctSortedValueTypes(rows: { value_type: string | null }[]): string[] {
  return [...new Set(rows.map((r) => r.value_type).filter((v): v is string => v != null))].sort(
    compareLabel,
  )
}
